import { ToastContainer, Flip } from "react-toastify";
import { IconButton } from "../../controls";

const ToastRoot = () => {
  return (
    <ToastContainer
      containerId={`toast-root`}
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      transition={Flip}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      closeButton={({ closeToast }) => (
        <IconButton
          data-testid="toast-close-button"
          isIcon="seem-icon-x-small"
          size="s"
          onClick={closeToast}
          className="custom-toast-close-button"
        />
      )}
    />
  );
};

export default ToastRoot;
